import { getUserList } from '@/api/user'
import files from '@/mixins/files'

export default {
  mixins: [files],
  data() {
    return {
      tagList: [],
      roleList: [],
      sites: [],
      article: {
        cover: { url: '' },
        links: [],
        tags: [],
        keywords: [],
        video: {},
        site_key: { key: '' },
      },
      notEmptyRules: [(v) => !!v || 'Это поле обязательно'],
      imageName: '',
      selectedSite: '',
    }
  },
  computed: {},
  methods: {
    getSites() {
      this.axios({ url: '/v1/sites', method: 'get' }).then((resp) => {
        this.sites = resp.data
      })
    },
    uploadImage(image) {
      let data = new FormData()
      data.append('file', image.file, image.name)
      return this.axios({
        url: '/v1/images',
        method: 'post',
        data: data,
        config: { headers: { 'content-type': 'multipart/form-data' } },
      })
    },
    /**
     * @param {Object} params to filter list of the users
     */
    getUserList(params) {
      return getUserList(this.axios, params)
    },
    getUser(id) {
      return this.axios({
        url: `/v1/users/${id}`,
        method: 'get',
      })
    },
    getRoleList() {
      this.axios({
        url: '/v1/roles',
        method: 'get',
      }).then((resp) => {
        const data = resp.data
        for (let x of data) {
          if (x.name) {
            this.roleList.push(x)
          }
        }
      })
    },
    getSite(key) {
      for (let i in this.sites) {
        if (this.sites[i].key === key) {
          return this.sites[i]
        }
      }
      return { key: '', name: '' }
    },
    getRole(key) {
      for (let i in this.roleList) {
        if (this.roleList[i].key === key) {
          return this.roleList[i]
        }
      }
    },
    pickFile() {
      this.$refs.imageInput.click()
    },
  },
}
